export default __webpack_public_path__ + "static/media/Category-21.3ed62581.jpg";